module.exports = __webpack_public_path__ + "img/Feature.d6aaa50e.jpg";